import React, { useEffect, useState } from 'react'
import AgGridContainer from '../../../componant/gridContainer/gridContainer'
import { getAllUserTask } from '../../../api-services/employee-services'
import AuditCellRender from '../../audit-cell-render/audit-cell-render'
import { formateISODate } from '../../../util_service/dateFormater/dateFormater'

const Task = () => {
    const [rowData, setRowData] = useState<any[]>([])

    const fetchData = () => {
        getAllUserTask().then((result: any) => {
            setRowData(result.data.payload)
        })
    }

    useEffect(() => {
        fetchData()
    }, [])

    const columnDefs = [
        {
            headerName: 'Employee Name',
            field: 'employeeName',
            filter: true,
        },
        {
            headerName: 'Project Name',
            field: 'projectName',
            filter: true
        },
        {
            headerName: 'Task',
            field: 'description'
        },
        {
            headerName: 'Creation Date',
            field: 'createdDate',
            filter: true,
            valueFormatter: (params: any) => {
                const value = formateISODate(params.value)
                return value
            }
        },
        {
            headerName: 'Action',
            field: '',
            cellRenderer: (params: any) => (
                <>
                    <AuditCellRender value={params.data} />
                </>
            ),
        },
    ]

    const handleOnGridReady = (params: any) => {
        params.api.sizeColumnsToFit();
    }

    return (
        <div className='main'>
            <div className="main-container">
                <div className='heading heading-start-center height-40'>
                    <h2>All Task List</h2>
                </div>
                <div className="cal-40">
                    <div className="container-100">
                        <AgGridContainer rowData={rowData} columnDefs={columnDefs} onGrid={handleOnGridReady} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Task
